// extracted by mini-css-extract-plugin
export default {"inputBox":"FtfOSR+bHWUSa7kRgoVnNQ==","inputText":"_5eJJTKlayN--lXQFI-mq8g==","input-field":"oaavnM5YYEFnBcyH1AQfLA== FtfOSR+bHWUSa7kRgoVnNQ== _5eJJTKlayN--lXQFI-mq8g=="};